import { render, staticRenderFns } from "./RequestStatus.vue?vue&type=template&id=5b410fe5&scoped=true"
import script from "./RequestStatus.vue?vue&type=script&lang=ts"
export * from "./RequestStatus.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b410fe5",
  null
  
)

export default component.exports